import React, {
  FunctionComponent,
  useEffect,
  useRef,
  useState,
} from 'react';
import { CheckboxType } from '../../types/checkbox';
import CheckIcon from '../icons/CheckIcon';
import Typography from '../typography/Typography';
import './checkbox.scss';

const Checkbox: FunctionComponent<CheckboxType> = ({
  isChecked,
  onChange,
  label,
  name,
  orientation = 'left',
  subText = '',
  className = '',
  labelClassName = '',
}) => {
  const [calculatedWidth, setCalculatedWidth] = useState<number>();
  const labelRef = useRef<HTMLLabelElement>(null);

  useEffect(() => {
    if (labelRef.current) {
      setCalculatedWidth(labelRef.current.offsetWidth + 10);
    }
  }, []);

  const checkBoxClasses = `
    checkbox-component 
    d-flex 
    align-items-center 
    ${orientation === 'right' ? 'flex-direction-row-reverse justify-content-space-between' : ''}
  `;
  return (
    <div data-testid="custom-checkbox" className={checkBoxClasses}>
      <div className={`
        d-flex
        align-items-center
        justify-content-center
        checkbox-wrapper 
        ${isChecked ? 'checked' : ''} 
        ${orientation === 'right' ? 'm-l-16' : 'm-r-16'}
      `}
      >
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          className={`${className}`}
          id={name}
        />
        {isChecked && (
          <CheckIcon width={15} color="light" />
        )}
      </div>
      <label
        className={`${labelClassName} ${subText ? 'd-flex flex-direction-column' : ''}`}
        htmlFor={name}
        style={{ width: `${calculatedWidth}px` }}
        ref={labelRef}
      >
        <Typography
          variant="body1"
          color={isChecked && !subText ? 'blue5' : 'dark'}
          className={`checkbox-label ${subText ? 'm-b-4' : ''} ${isChecked ? 'f-w-500' : ''}`}
        >
          {label}
        </Typography>
        {subText && (
          <Typography
            variant="body2"
            color={isChecked ? 'blue5' : 'asphalt5'}
            className={`checkbox-sub-text ${isChecked ? 'f-w-500' : ''}`}
          >
            {subText}
          </Typography>
        )}
      </label>
    </div>
  );
};

export default Checkbox;
